import React from "react";
import TextInput from "components/FormElements/TextInput";

function PrintonlyMetaProperty(props) {
    return <TextInput name={props.name} type="hidden" />;
}

export default PrintonlyMetaProperty;

export const Property = PrintonlyMetaProperty;

export const Label = "Print Only/Hidden";
